import { Component } from '@angular/core';

@Component({
  selector: 'app-main-payments',
  templateUrl: './main-payments.component.html',
  styleUrls: ['./main-payments.component.css'],
})
export class MainPaymentsComponent {}
